import _draftJs from 'draft-js';

('use strict');
// Object.defineProperty(exports, '__esModule', {
//   value: true,
// });
Object.defineProperty(window.exports || {}, '__esModule', {
  value: true,
});

var insertText = function insertText(editorState, text) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var newContentState = _draftJs.Modifier.insertText(
    content,
    selection,
    text,
    editorState.getCurrentInlineStyle(),
  );
  return _draftJs.EditorState.push(editorState, newContentState, 'insert-fragment');
};
var _default = insertText;
export default _default;
